// Centralised test IDs used by Emergent's testing agent.
export const HOME = { emergentLink: "home-emergent-link" };

export const LOGIN = {
    root: "login-page",
    email: "login-email-input",
    pin: "login-pin-input",
    password: "login-password-input",
    submit: "login-submit-btn",
    togglePassword: "login-toggle-password-mode",
    togglePin: "login-toggle-pin-mode",
    error: "login-error",
};

export const FORCE_CHANGE = {
    dialog: "force-change-dialog",
    current: "force-change-current-input",
    newPassword: "force-change-new-password-input",
    newPin: "force-change-new-pin-input",
    submit: "force-change-submit-btn",
    error: "force-change-error",
};

export const SHELL = {
    sidebar: "admin-sidebar",
    linkDashboard: "nav-dashboard",
    linkUsers: "nav-users",
    linkClients: "nav-clients",
    linkJobs: "nav-jobs",
    linkTimesheet: "nav-timesheet",
    linkSchedule: "nav-schedule",
    linkApprovals: "nav-approvals",
    linkReports: "nav-reports",
    linkSettings: "nav-settings",
    logout: "shell-logout-btn",
    userChip: "shell-user-chip",
};

export const DASHBOARD = {
    root: "admin-dashboard",
    tileUsers: "tile-users",
    tileJobsActive: "tile-jobs-active",
    tileClients: "tile-clients",
    tileJobsOpen: "tile-jobs-open",
    activity: "dashboard-activity",
};

export const USERS = {
    root: "users-list",
    newBtn: "users-new-btn",
    row: (id) => `user-row-${id}`,
    editor: "user-editor",
    saveBtn: "user-editor-save",
    addRateBtn: "user-editor-add-rate",
    addRateDialog: "add-rate-dialog",
    addRateAmount: "add-rate-amount",
    addRateScope: "add-rate-scope",
    addRateReason: "add-rate-reason",
    addRateSubmit: "add-rate-submit",
};

export const CLIENTS = {
    root: "clients-list",
    newBtn: "clients-new-btn",
    row: (id) => `client-row-${id}`,
    editor: "client-editor",
    saveBtn: "client-editor-save",
};

export const JOBS = {
    root: "jobs-list",
    newBtn: "jobs-new-btn",
    filterStatus: "jobs-filter-status",
    search: "jobs-search",
    row: (id) => `job-row-${id}`,
    detail: "job-detail",
    addVariationBtn: "job-add-variation",
    addContractorCostBtn: "job-add-contractor-cost",
};

export const MOBILE = {
    todayRoot: "m-today",
    jobsRoot: "m-jobs",
    weekRoot: "m-week",
    profileRoot: "m-profile",
    addRoot: "m-add",
    jobDetail: "m-job-detail",
    stopped: "m-stopped",
    tabBar: "m-tab-bar",
    tabToday: "m-tab-today",
    tabJobs: "m-tab-jobs",
    tabWeek: "m-tab-week",
    tabProfile: "m-tab-profile",
    offlineBanner: "m-offline-banner",
    fabAdd: "m-fab-add",
    runningCard: "m-running-card",
    timer: "m-timer",
    startBtn: "m-start-btn",
    stopBtn: "m-stop-btn",
    variationToggle: "m-variation-toggle",
    variationNote: "m-variation-note",
    stoppedBack: "m-stopped-back",
    searchJobs: "m-search-jobs",
    newAddress: "m-new-address",
    startHere: "m-start-here",
    pushSubscribe: "m-push-subscribe",
    pushTest: "m-push-test",
    logoutBtn: "m-logout-btn",
};

export const TIMESHEET = {
    root: "timesheet-root",
    grid: "timesheet-grid",
    prevWeek: "ts-prev-week",
    nextWeek: "ts-next-week",
    employeePicker: "ts-employee-picker",
    addRow: "ts-add-row",
    submit: "ts-submit",
    approve: "ts-approve",
    reject: "ts-reject",
    rejectReason: "ts-reject-reason",
    historyRoot: "ts-history",
};

export const ADMIN = {
    // Live dashboard
    livePanel: "admin-live-panel",
    liveRow: (id) => `admin-live-row-${id}`,
    varsTodayPanel: "admin-vars-today-panel",
    // Schedule
    scheduleRoot: "admin-schedule",
    schedulePrev: "admin-schedule-prev",
    scheduleNext: "admin-schedule-next",
    scheduleWeekLabel: "admin-schedule-week",
    scheduleGrid: "admin-schedule-grid",
    schedulePublish: "admin-schedule-publish",
    jobPool: "admin-schedule-job-pool",
    scheduleCell: (userId, day) => `sched-cell-${userId}-${day}`,
    scheduleCard: (id) => `sched-card-${id}`,
    // Approvals
    approvalsRoot: "admin-approvals",
    approvalRow: (id) => `approval-row-${id}`,
    approvalCheckbox: (id) => `approval-check-${id}`,
    approvalBulk: "approval-bulk-approve",
    variationsList: "admin-variations-list",
    variationRow: (id) => `variation-row-${id}`,
    resolveDialog: "resolve-variation-dialog",
    resolveAmount: "resolve-variation-amount",
    resolveNotes: "resolve-variation-notes",
    resolveSubmit: "resolve-variation-submit",
    // Job audit
    auditRoot: "admin-job-audit",
    auditBar: "audit-margin-bar",
    auditActivity: "audit-activity",
    auditActivityRow: (id) => `audit-row-${id}`,
    rateOverrideBtn: (id) => `rate-override-btn-${id}`,
    rateOverrideDialog: "rate-override-dialog",
    rateOverrideAmount: "rate-override-amount",
    rateOverrideReason: "rate-override-reason",
    rateOverrideSubmit: "rate-override-submit",
    // Reports
    reportsRoot: "admin-reports",
    reportsTable: "admin-reports-table",
    reportsExportJobs: "reports-export-jobs",
    reportsExportUsers: "reports-export-users",
    reportsExportTime: "reports-export-time",
    reportsPdf: "reports-pdf-stub",
    reportsEmail: "reports-email-stub",
    // Settings
    settingsRoot: "admin-settings",
    settingsSave: "settings-save",
};

